import { ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { OverviewDetailsComponent } from 'app/modules/order-management/components/order-details/overview-details/overview-details.component';
// import { DocumentListComponent } from 'app/modules/shared/components/document-list/document-list.component';
import { NoResultFoundComponent } from 'app/modules/shared/components/no-result-found/no-result-found.component';
import { AccessProviderDirective } from 'app/modules/shared/directives/access-provider.directive';
import { StorageService } from 'app/modules/shared/services/storage.service';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { MenuModule } from 'primeng/menu';
import { TabViewModule } from 'primeng/tabview';
import { ToastModule } from 'primeng/toast';
import { AppSettings } from '../../../shared/app.settings';
import { StatusComponent } from '../../../shared/components/status/status.component';
import type { Country } from '../../../shared/models/country';
import type { Status } from '../../../shared/models/status';
import { CommonBindingDataService } from '../../../shared/services/common-binding-data.service';
import { EntityService } from '../../../shared/services/entity.service';
// import { VehicleJourneyHistoryComponent } from '../vehicle-journey-history/vehicle-journey-history.component';
// import { SpecificationComponent } from './specification/specification.component';
// import { VehicleAssignmentHistoryComponent } from './vehicle-assignment-history/vehicle-assignment-history.component';
// import { VehicleFeaturesComponent } from './vehicle-features/vehicle-features/vehicle-features.component';

@Component({
  selector: 'app-order-details',
  standalone: true,
  imports: [
    BreadcrumbModule,
    StatusComponent,
    TabViewModule,
    TranslateModule,
    MenuModule,
    ToastModule,
    ButtonModule,
    OverviewDetailsComponent,   
    // SpecificationComponent,
    // VehicleAssignmentHistoryComponent,
    // DocumentListComponent,
    AccessProviderDirective,
    // VehicleJourneyHistoryComponent,
    NoResultFoundComponent,
    // VehicleFeaturesComponent
  ],
  templateUrl: './order-details.component.html',
  styleUrl: './order-details.component.scss'
})

export class OrderDetailsComponent implements OnInit {
  @Input() tableData: any[];
  routePath: MenuItem[] = [];
  vehicleId: string;
  dataForVehicleStatus: Array<Status> = [];
  userId: any = '';
  country: Country;
  activeIndex: any = 0;
  data: any;
  vehicleAttributeData: any;
  attributeLabels = {};
  vehicleAttributeLength;
  attributeValues = [];
  imgFileId: any;
  imgFileUrl: any;
  showStatus: boolean = false;
  vehicleEntityId;
  currentRow;
  vehicleDetails: any;
  entityForStatus: any;
  editBtnLabel: any;
  relatedData: any;
  driverList: any[] = [];
  defaultLoaderImg = AppSettings.DEFAULT_LOADER_IMAGE;
  entityCode: string = AppSettings.ENTITY_CODE.VEHICLE_DOCUMENT;
  isUnassigned: boolean =false;
  isDeleted: boolean = false;

  constructor(private route: ActivatedRoute,
    public cs: CommonBindingDataService,
    private cd: ChangeDetectorRef,
    private vehicleService: EntityService,
    private storageService: StorageService,
    private router: Router) {

  }

  ngOnInit() {
    this.editBtnLabel = this.cs.getLabel('lbl_edit');
    this.vehicleId = this.route.snapshot.paramMap.get('id');
    this.getVehicleDetails();

    this.getAttributeData();

    // Check if navigated from dashboard
    const fromDashboard = this.route.snapshot.queryParamMap.get('fromDashboard');
    const fromTab = this.route.snapshot.queryParamMap.get('fromTab');
    const protocolId = this.route.snapshot.queryParamMap.get('protocolId');
    const siteId = this.route.snapshot.queryParamMap.get('siteId');

    this.routePath = [
      {
        label: "Orders",
        routerLink: fromDashboard === 'true' ? '/app/dashboard' : '/app/orders',
        icon: 'pi pi-arrow-left',
        iconStyle: { 'font-weight': 'bold', 'margin-right': '10px' },
        command: () => {
          if (fromDashboard === 'true') {
            // Build query params to restore dashboard filter state
            const dashboardParams: any = {};
            if (protocolId) {
              dashboardParams.protocolId = protocolId;
            }
            if (siteId) {
              dashboardParams.siteId = siteId;
            }
            this.router.navigate(['/app/dashboard'], { queryParams: dashboardParams });
          } else {
            if (fromTab) {
              this.router.navigate(['/app/orders'], { queryParams: { tab: fromTab } });
            } else {
              this.router.navigate(['/app/orders']);
            }
          }
        }
      },
      {
        label: "Overview",
        routerLink: `../${  this.vehicleId}`,
        styleClass: 'breadcrumb-child forward-slash breadcrumb-text',
        style: { 'display': 'flex', 'top': '2px', 'position': 'relative' }
      },
    ];
    this.vehicleService.entityCurrentRow.subscribe(res => {
      this.currentRow = res;
    })
  }

  onAddVehicleDocument() {
    this.router.navigate([`app/orders/add/${this.vehicleId}`]);
  }

  activeIndexChange(event) {
    this.storageService.setItem('vehicleActiveIndex', event);
  }

  getAttributeData() {
    // this.country = JSON.parse(localStorage.getItem(AppSettings.COUNTRY));
    // this.vehicleService.getAttributeDefinition(AppSettings.ENTITY_CODE.VEHICLE, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe(res => {
    //   res.tabs.forEach(element => {
    //     element.groups.forEach(group => {
    //       if (group.code === 'details') {
    //         group.entityRelationshipConfigId = null;
    //       }
    //     });
    //   });
    //   this.data = res;
    //   this.attributeLabels = this.cs.getAttributeLabels(this.data);
    //   this.vehicleAttributeData = this.cs.getOrganizedAttribute(this.data);
    //   this.vehicleAttributeLength = this.vehicleAttributeData.tabs.length;
    //   this.cd.detectChanges();
    // })
  }

  getVehicleDetails() {
    // this.vehicleService.getEntity(this.vehicleId, AppSettings.ENTITY_CODE.VEHICLE, AppSettings.VIEW_CODE.DETAIL_VIEW).subscribe((result: any) => {
    //   this.attributeValues = this.cs.getOrgAttributeValues(result);
    //   this.vehicleDetails = result;
    //   this.isDeleted = this.getDeleted();
    //   this.isUnassigned = this.getUnassigned();
    //   const value = result.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'vehicle_images_url');
    //   this.driverList = result.relatedData.filter(ele => ele.entityCode === 'driver').map(ele => {
    //     return {
    //       driverProfileImage:  ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'driver_profile_image_url')?.attributeValue[0],
    //       driverProfileImageId: ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'driver_profile_image')?.attributeValue[0],
    //       driverName: ` ${ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'first_name').attributeValue} ${ele.attributeCodeValueDtoList.find(ele => ele.attributeCode === 'last_name').attributeValue}`
    //     }
    //   });

    //   if (value) {
    //     this.imgFileUrl = value.attributeValue[0];
    //     this.cd.detectChanges();
    //   }
    //   this.showStatus = true;
    //   this.setStatusData();
    // })
  }

  setStatusData() {
    const findAttributeValue = (attributeCode: string) =>
      this.vehicleDetails?.attributeCodeValueDtoList.find(ele => ele.attributeCode === attributeCode)?.attributeValue;

    const getAttributeValueOrEmpty = (attributeCode: string) =>
      findAttributeValue(attributeCode) || this.cs.getLabel('lbl_empty');

    this.entityForStatus = {
      entityName: `${findAttributeValue('name_code')}`,
      entityStatus: `${findAttributeValue('vehicle_status')}`
    };

    this.dataForVehicleStatus = [
      { userId: '', vehicleType: 'type', label: '', text: getAttributeValueOrEmpty('vehicle_type') },
      { label: '', text: getAttributeValueOrEmpty('year_of_manufacturing') },
      { label: '', text: findAttributeValue('manufacturer') },
      { label: '', text: findAttributeValue('model') },
      { label: 'VIN', text: findAttributeValue('vin_chassis_no') },
      { label: 'License Plate', text: findAttributeValue('reg_number') },
    ];
  }
}

